import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/lib/store";
import BottomNav from "@/components/BottomNav";
import Intro from "@/pages/Intro";
import Mission from "@/pages/Mission";
import Landing from "@/pages/Landing";
import Navigate from "@/pages/Navigate";
import History from "@/pages/History";
import Pattern from "@/pages/Pattern";
import Settings from "@/pages/Settings";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import Plus from "@/pages/Plus";
import PaymentReturn from "@/pages/PaymentReturn";
import OperatingStates from "@/pages/OperatingStates";
import LoadRecovery from "@/pages/LoadRecovery";
import ManageSubscription from "@/pages/ManageSubscription";
import Home from "@/pages/Home";
import Lens from "@/pages/Lens";
import Start from "@/pages/Start";
import FromScoreApp from "@/pages/FromScoreApp";
import Reflection from "@/pages/Reflection";
import { PrivacyPolicy, Terms, FAQ } from "@/pages/LegalPage";

function AppShellRoutes() {
  return (
    <>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/reflection" element={<Reflection />} />
        <Route path="/navigate" element={<Navigate />} />
        <Route path="/history" element={<History />} />
        <Route path="/pattern" element={<Pattern />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
      <BottomNav />
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors={false} />
        <div className="ss-dark min-h-dvh">
        <Routes>
          <Route path="/" element={<Mission />} />
          <Route path="/intro" element={<Intro />} />
          <Route path="/start" element={<Start />} />
          <Route path="/from-scoreapp" element={<FromScoreApp />} />
          <Route path="/lens/:lensId" element={<Lens />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/auth/verify" element={<Auth />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/plus" element={<Plus />} />
          <Route path="/operating-states" element={<OperatingStates />} />
          <Route path="/load-recovery" element={<LoadRecovery />} />
          <Route path="/manage-subscription" element={<ManageSubscription />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment/success" element={<PaymentReturn />} />
          <Route path="/payment/cancel" element={<PaymentReturn />} />
          <Route path="/*" element={<AppShellRoutes />} />
        </Routes>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
